import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=1214c30c&scoped=true"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"
import style0 from "./pages.vue?vue&type=style&index=0&id=1214c30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214c30c",
  null
  
)

export default component.exports